import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    cart:[]
}

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers:{
        addToCart: (state, action) => {
            const item = action.payload;
            const existingItem = state.cart.find(cartItem => cartItem.id === item.id && cartItem.size === item.size)
            if(existingItem){
                if(existingItem.quantity < existingItem.totalQuantity){
                existingItem.quantity += 1
                alert("Item added to cart");
            }
            }else{
                if(item.quantity <= item.totalQuantity){
                state.cart.push(item);
                alert("item successfully added to cart")
              }else{
                alert("minimum quantity must be 1")
              }   
            }
        },
        removeFromCart: (state, action) => {
            const { id, size} = action.payload;
            state.cart = state.cart.filter(
                item => !(item.id === id && item.size == size)
            )
           // alert("Item removed from cart");
        },
        clearCart: (state) =>{
            state.cart = [];
        },
        updateQuantity: (state, action) => {
            const { id, size} = action.payload;
            const item = state.cart.find(
                item => item.id === id && item.size === size
            )
            if(!item) return

            if(item.quantity < item.totalQuantity){
                item.quantity += 1
                //alert("quantity updated");
            }
        },
         reduceQuantity: (state, action) => {
            const { id, size} = action.payload;
            const item = state.cart.find(
                item => item.id === id && item.size === size
            )
            if(!item) return

            if(item.quantity > 1){
                item.quantity -= 1
                //alert("quantity reduced");
            }
        }
    }
})

export const {
    addToCart, removeFromCart, clearCart, updateQuantity, reduceQuantity
} = cartSlice.actions;

export default cartSlice.reducer;